// extracted by mini-css-extract-plugin
module.exports = {"caretWrapper":"regulatoryFees_caretWrapper__zJO_A","upCaret":"regulatoryFees_upCaret__KYr_a","expandedSection":"regulatoryFees_expandedSection__N5cI0"};